module.exports = {
    "page.asc.feedback.title": "แบบฟอร์มข้อเสนอแนะ",
    "page.common.needhelp": "ต้องการความช่วยเหลือ",
    "page.lu.feedback.subtitle": "ขอบคุณที่สละเวลาให้ข้อเสนอแนะแก่เรา \nเราจะใช้ข้อเสนอแนะของคุณเพื่อปรับปรุงประสบการณ์ Lazada สำหรับทุกคน",
    "page.asc.feedback.phoneHolder": "กรุณากรอกข้อมูลให้ถูกต้อง ทีมงานของเราอาจติดต่อคุณผ่านทางนี้",
    "page.asc.onboarding.feedback.subtitle": "ยินดีต้อนรับสู่ Lazada เราพร้อมที่จะช่วยเหลือคุณ \nกรุณากรอกแบบฟอร์มนี้เพื่อบอกปัญหาของคุณเมื่อเข้าสู่ระบบหรือสมัครบัญชี \nนอกจากนี้ หากคุณมีข้อเสนอแนะหรือความคิดเห็นใด ๆ ก็สามารถเขียนลงไปได้เลย",
    "page.asc.feedback.emailHolder": "กรุณากรอกข้อมูลให้ถูกต้อง ทีมงานของเราอาจติดต่อคุณผ่านทางนี้",
    "layout.toolbar.feedback.freezen.title": "ข้อเสนอแนะ",
    "page.asc.feedback.descHolder": "กรุณาแชร์รายละเอียดเพิ่มเติมกับเรา"
};